// extracted by mini-css-extract-plugin
module.exports = {"canvasHidden":"styles_canvasHidden__dLizw","container":"styles_container__1TQEm","content":"styles_content__gu6-4","picContainer":"styles_picContainer__uoM2_"};